import React from "react";
import SignupForm from "../components/signup/SignUpForm";

const Signup = () => {
  return <SignupForm />;
};

export default Signup;
